import styled from '@emotion/styled'

import { useIntl } from 'react-intl'
import { useRecoilValue } from 'recoil'

import {
  Divider,
  Flex,
  FlexItem,
  Grid,
  GridCell,
  MESSAGE_BOX_VARIANT_HELP,
  MessageBox,
  Panel,
  SPACING_24,
  SPACING_8,
  SpacingVertical,
  Text,
  TEXT_VARIANT_LIGHT,
  Title,
  TITLE_VARIANT_S,
  TITLE_VARIANT_XL
} from 'mailup-web-components'

import ImgEmailOpens from 'mailup-web-components/bundle/img/icons/statistica-aperture.svg'
import ImgSmsClicks from 'mailup-web-components/bundle/img/icons/statistica-clic-sms.svg'
import ImgEmailClicks from 'mailup-web-components/bundle/img/icons/statistica-clic.svg'
import ImgSmsSent from 'mailup-web-components/bundle/img/icons/statistica-invii-sms.svg'
import ImgEmailSent from 'mailup-web-components/bundle/img/icons/statistica-invii.svg'
import ImgSmsDelivered from 'mailup-web-components/bundle/img/icons/statistica-recapitati-sms.svg'

import {
  showCumulativeStatisticsState,
  totalStatsState
} from '../recoil/state/workflow'

import {
  WORKFLOW_MESSAGE_TYPE_EMAIL,
  WORKFLOW_MESSAGE_TYPE_SMS
} from 'Api/beAutomationApi'

const CombinedStatisticsBlock = () => {
  const intl = useIntl()

  const {
    totalClicks: totalClicksEmail,
    totalViewOrDelivered: totalViewOrDeliveredEmail,
    totalSend: totalSendEmail,
    totalRec: totalRecEmail
  } = useRecoilValue(totalStatsState(WORKFLOW_MESSAGE_TYPE_EMAIL))

  const {
    totalClicks: totalClicksSms,
    totalViewOrDelivered: totalViewvOrDeliveredSms,
    totalSend: totalSendSms
  } = useRecoilValue(totalStatsState(WORKFLOW_MESSAGE_TYPE_SMS))

  const [showEmailStats, showSmsStats] = useRecoilValue(
    showCumulativeStatisticsState
  )

  const getPercentageEmail = (data) => {
    if (totalRecEmail <= 0) {
      return '0.0'
    }
    return intl.formatNumber((data / totalRecEmail) * 100, {
      maximumFractionDigits: 1
    })
  }

  const getPercentageSms = (data) => {
    if (totalSendSms <= 0) {
      return '0.0'
    }
    return intl.formatNumber((data / totalSendSms) * 100, {
      maximumFractionDigits: 1
    })
  }

  return (
    <Panel data-mu-test='workflow-statistics__combined-statistics'>
      <Title variant={TITLE_VARIANT_S}>
        {intl.formatMessage({
          id: 'Load.AutomationWorkflowTroubleshooting.CumulativeStatistics'
        })}
      </Title>
      <SpacingVertical variant={SPACING_8} />
      {showEmailStats && (
        <Grid cols={12}>
          <GridCell span={4}>
            <Flex alignItems='center'>
              <FlexItem margin='0 8px 0 0'>
                <img src={ImgEmailSent} />
              </FlexItem>
              <FlexItem>
                <StyledTitleBold variant={TITLE_VARIANT_XL}>
                  {intl.formatNumber(totalSendEmail)}
                </StyledTitleBold>
                <Text variant={TEXT_VARIANT_LIGHT}>
                  {intl.formatMessage({
                    id: 'Load.MailupCommon.Sent'
                  })}
                </Text>
              </FlexItem>
            </Flex>
          </GridCell>
          <GridCell span={4}>
            <Flex alignItems='center'>
              <FlexItem margin='0 8px 0 0'>
                <img src={ImgEmailOpens} />
              </FlexItem>
              <FlexItem>
                <Flex alignItems='baseline'>
                  <StyledTitleBold variant={TITLE_VARIANT_XL}>
                    {getPercentageEmail(totalViewOrDeliveredEmail)}
                  </StyledTitleBold>
                  <FlexItem margin='0 0 0 4px'>%</FlexItem>
                </Flex>
                <Text variant={TEXT_VARIANT_LIGHT}>
                  {intl.formatMessage({
                    id: 'Load.Statistics.PercOpen'
                  })}
                </Text>
              </FlexItem>
            </Flex>
          </GridCell>
          <GridCell span={4}>
            <Flex alignItems='center'>
              <FlexItem margin='0 8px 0 0'>
                <img src={ImgEmailClicks} />
              </FlexItem>
              <FlexItem>
                <Flex alignItems='baseline'>
                  {' '}
                  <StyledTitleBold variant={TITLE_VARIANT_XL}>
                    {getPercentageEmail(totalClicksEmail)}
                  </StyledTitleBold>
                  <FlexItem margin='0 0 0 4px'>%</FlexItem>
                </Flex>
                <Text variant={TEXT_VARIANT_LIGHT}>
                  {intl.formatMessage({
                    id: 'Load.Statistics.PercClick'
                  })}
                </Text>
              </FlexItem>
            </Flex>
          </GridCell>
        </Grid>
      )}
      {showEmailStats && showSmsStats && (
        <FlexItem margin='24px 0' width='100%' flexDirection='column'>
          <Divider />
          <Divider />
        </FlexItem>
      )}
      {showSmsStats && (
        <Grid cols={12}>
          <GridCell span={4}>
            <Flex alignItems='center'>
              <FlexItem margin='0 8px 0 0'>
                <img src={ImgSmsSent} />
              </FlexItem>
              <FlexItem>
                <StyledTitleBold variant={TITLE_VARIANT_XL}>
                  {intl.formatNumber(totalSendSms)}
                </StyledTitleBold>
                <Text variant={TEXT_VARIANT_LIGHT}>
                  {intl.formatMessage({
                    id: 'Load.MailupCommon.Sent'
                  })}
                </Text>
              </FlexItem>
            </Flex>
          </GridCell>
          <GridCell span={4}>
            <Flex alignItems='center'>
              <FlexItem margin='0 8px 0 0'>
                <img src={ImgSmsDelivered} />
              </FlexItem>
              <FlexItem>
                <Flex alignItems='baseline'>
                  <StyledTitleBold variant={TITLE_VARIANT_XL}>
                    {getPercentageSms(totalViewvOrDeliveredSms)}
                  </StyledTitleBold>
                  <FlexItem margin='0 0 0 4px'>%</FlexItem>
                </Flex>
                <Text variant={TEXT_VARIANT_LIGHT}>
                  {intl.formatMessage({
                    id: 'Load.Statistics.PercDelivered'
                  })}
                </Text>
              </FlexItem>
            </Flex>
          </GridCell>
          <GridCell span={4}>
            <Flex alignItems='center'>
              <FlexItem margin='0 8px 0 0'>
                <img src={ImgSmsClicks} />
              </FlexItem>
              <FlexItem>
                <Flex alignItems='baseline'>
                  <StyledTitleBold variant={TITLE_VARIANT_XL}>
                    {getPercentageSms(totalClicksSms)}
                  </StyledTitleBold>
                  <FlexItem margin='0 0 0 4px'>%</FlexItem>
                </Flex>
                <Text variant={TEXT_VARIANT_LIGHT}>
                  {intl.formatMessage({
                    id: 'Load.Statistics.PercClick'
                  })}
                </Text>
              </FlexItem>
            </Flex>
          </GridCell>
        </Grid>
      )}
      <SpacingVertical variant={SPACING_24} />
      <MessageBox variant={MESSAGE_BOX_VARIANT_HELP}>
        {intl.formatMessage({
          id: 'Load.AutomationWorkflowTroubleshooting.StatNote'
        })}
      </MessageBox>
    </Panel>
  )
}

export default CombinedStatisticsBlock

const StyledTitleBold = styled(Title)`
  font-weight: 500 !important;
`
